// ABOUTME: Loading state of a page inside the app shell — top progress bar plus card skeletons.
// ABOUTME: Replaces a centred spinner: the shell is already there, so the page fills in, not blinks.

import type { FC } from "react"
import { useTranslation } from "react-i18next"
import { cn } from "@shared/lib/utils"
import { CIndeterminateBar } from "./CIndeterminateBar"

interface CPageLoadingProps {
  /** How many card placeholders to draw. */
  cards?: number
  className?: string
}

export const CPageLoading: FC<CPageLoadingProps> = ({ cards = 8, className }) => {
  const { t } = useTranslation()

  return (
    <div
      role="status"
      aria-label={t("common.loading")}
      className={cn("relative flex h-full flex-col bg-customGray-100", className)}
    >
      <CIndeterminateBar
        loading
        className="h-[3px]"
      />

      <div className="flex items-center gap-3 border-b border-border bg-white px-5 py-4">
        <span className="h-3.5 w-35 animate-pulse rounded-md bg-secondary" />
        <span className="ml-auto h-[30px] w-24 animate-pulse rounded-lg bg-secondary" />
      </div>

      <div className="grid grid-cols-1 content-start gap-4 p-5 sm:grid-cols-2 lg:grid-cols-4">
        {Array.from({ length: cards }, (_, i) => (
          <div
            key={i}
            className="flex animate-pulse flex-col gap-3 rounded-xl bg-white p-4 shadow-cardShadow"
          >
            <span className="h-3 w-3/5 rounded-md bg-secondary" />
            <span className="h-8 w-full rounded-lg bg-muted" />
            <span className="h-3 w-2/5 rounded-md bg-secondary" />
          </div>
        ))}
      </div>
    </div>
  )
}
